export const isZero = (value) => {
    const numericValue = parseFloat(value.replace(/[^\d.-]/g, '').replace(',', '.'));
    return numericValue === 0;
};
